// Para obtener la documentación completa sobre las funciones API, incluidos ejemplos para programa con código, visita http://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {


});